import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';



const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="tw-min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-gradient-to-br tw-from-[#f0f7f3] tw-via-white tw-to-[#e8f0eb]">
                <div className="tw-w-14 tw-h-14 tw-rounded-2xl tw-border-4 tw-border-primary/20 tw-border-t-primary tw-animate-spin" aria-hidden />
                <p className="tw-mt-6 tw-text-sm tw-font-medium tw-text-gray-600">Duke verifikuar sesionin…</p>
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: location.pathname }} />;
    }

    return children;
};

export default ProtectedRoute;
